export const NewCourseCardSkeleton = () => {
  return (
    <article className="rounded-lg border border-lines bg-mydra-white">
      <div className="flex h-full flex-col gap-6 p-4">
        <header className="flex flex-col gap-4">
          {/* Title skeleton - 2 lines */}
          <div className="space-y-2">
            <div className="h-7 w-full animate-pulse rounded bg-mydra-mouse" />
            <div className="h-7 w-3/4 animate-pulse rounded bg-mydra-mouse" />
          </div>
          
          {/* Category chip and duration skeleton */}
          <div className="flex items-center gap-2">
            <div className="h-6 w-20 animate-pulse rounded-full bg-mydra-mouse" />
            <div className="h-1 w-1 animate-pulse rounded-full bg-mydra-mouse" />
            <div className="h-4 w-16 animate-pulse rounded bg-mydra-mouse" />
          </div>
        </header>

        <div className="mt-auto flex flex-col gap-4">
          {/* Course instructors skeleton - avatar images */}
          <div className="flex items-center gap-3">
            <div className="flex shrink-0">
              <div className="h-10 w-10 animate-pulse rounded-full bg-mydra-mouse" />
              <div className="-ml-2 h-10 w-10 animate-pulse rounded-full bg-mydra-mouse" />
            </div>
            <div className="flex flex-col gap-1">
              <div className="h-4 w-32 animate-pulse rounded bg-mydra-mouse" />
              <div className="h-4 w-24 animate-pulse rounded bg-mydra-mouse" />
            </div>
          </div>

          {/* Description skeleton - 2 lines */}
          <div className="space-y-2">
            <div className="h-4 w-full animate-pulse rounded bg-mydra-mouse" />
            <div className="h-4 w-5/6 animate-pulse rounded bg-mydra-mouse" />
          </div>
        </div>

        {/* Footer button skeleton */}
        <footer className="mt-auto">
          <div className="h-12 w-full animate-pulse rounded-xl bg-mydra-mouse" />
        </footer>
      </div>
    </article>
  )
}

